/**
 * @Description: 用户的发票抬头信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  ShoppingInvoiceModel,
  ShoppingInvoiceSearchModel,
  ShoppingInvoicePageSearchModel,
  ShoppingInvoiceAddModel,
  ShoppingInvoiceUpdateModel,
  IdsModel
} from '@/model/product/ShoppingInvoiceModel'

const baseUrl = Route.product + '/shoppingInvoice'

/**
 * 搜索分页数据
 */
export const pageSearchShoppingInvoice = (param: ShoppingInvoicePageSearchModel) => {
  return https().request<RootObject<PageRespModel<ShoppingInvoiceModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchShoppingInvoice = (param: ShoppingInvoiceSearchModel) => {
  return https().request<RootObject<ShoppingInvoiceModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getShoppingInvoice = (id: number) => {
  return https().request<RootObject<ShoppingInvoiceModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addShoppingInvoice = (param: ShoppingInvoiceAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateShoppingInvoice = (param: ShoppingInvoiceUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeShoppingInvoice = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveShoppingInvoice = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
